export const layout = {
  searchStocks: "Search Stocks & ETFs",
  search: "Search",
  login: "Login",
  signUp: "Sign up",
  profileLabel: "Profile",
  footerRights: "© {{year}} Akinda. All rights reserved.",
  profileMenu: {
    personalInfo: "Personal info",
    mySubscription: "My subscription",
    notificationSettings: "Notification settings",
    myTickets: "My Tickets",
    myCourses: "My Courses",
    myPortfolio: "My Portfolio",
    myCards: "My Cards",
    signOut: "Sign out",
  },
} as const;
